import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-28 md:py-36 flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20warm%20atmospheric%20illustration%2C%20cozy%20reading%20nook%20with%20soft%20warm%20golden%20lighting%2C%20autumn%20vibes%2C%20digital%20painting%20style%2C%20dreamy%20ambient%20glow%2C%20clean%20composition%20with%20space%20for%20text%2C%20warm%20amber%20and%20coral%20tones%2C%20no%20text&width=1920&height=800&seq=cta-manga-home&orientation=landscape"
          alt="虫虫漫画网 - 立即开始免费阅读"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/40 to-foreground-950/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-3xl mx-auto px-6 text-center">
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 mb-5 tracking-tight">
          立即加入虫虫漫画
        </h2>
        <p className="text-base md:text-lg text-background-50/75 mb-10 leading-relaxed max-w-xl mx-auto">
          2000+ 韩国漫画任你畅读，下拉式完整版免费阅读
          <br />
          无删减内容，流畅不卡顿，立即开启你的漫画之旅
        </p>
        <Link
          to="/category/new"
          className="inline-flex items-center gap-3 px-8 py-4 bg-foreground-950 text-background-50 rounded-full text-sm md:text-base font-medium hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap group cursor-pointer"
        >
          <span className="w-6 h-6 rounded-full bg-primary-500 flex items-center justify-center">
            <i className="ri-play-fill text-background-50 text-xs"></i>
          </span>
          免费开始阅读
          <i className="ri-arrow-right-up-line text-lg group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200"></i>
        </Link>
      </div>
    </section>
  );
}